import { FC, memo } from 'react';
import '../../estilos/estilos.scss';
import ReactHtmlParser from 'react-html-parser';

export interface AvisoDeInconsistenciaProps {
  inconsistencias?: string[];
  mensagemDeAlerta?: string;
  titulo?: string;
  visivel?: boolean | string;
}

const arraysIguais = (a: string[] = [], b: string[] = []) =>
  a.length === b.length && a.every((item, i) => item === b[i]);

const AvisoDeInconsistencia: FC<AvisoDeInconsistenciaProps> = ({
  visivel = false,
  mensagemDeAlerta = '',
  titulo = 'Atenção!',
  inconsistencias = [],
}) => {
  const classeVisibilidade = visivel ? 'aviso-de-inconsistencia_visivel' : '';

  return (
    <div
      id="aviso-de-inconsistencia"
      tabIndex={0}
      role="alert"
      aria-hidden={!visivel}
      className={`aviso-de-inconsistencia ${classeVisibilidade}`}
    >
      <h4 className="aviso-de-inconsistencia__titulo">
        <i className="fal fa-exclamation-triangle" aria-hidden="true" /> {titulo}
      </h4>

      {mensagemDeAlerta && (
        <p className="aviso-de-inconsistencia__paragrafo u-margem-superior-pequena">
          {mensagemDeAlerta}
        </p>
      )}

      {inconsistencias.length > 0 && (
        <ul className="aviso-de-inconsistencia__lista">
          {inconsistencias.map((inconsistencia, index) => (
            <li key={index}>{ReactHtmlParser(inconsistencia)}</li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default memo(AvisoDeInconsistencia, (prev, next) =>
  prev.visivel === next.visivel &&
  prev.mensagemDeAlerta === next.mensagemDeAlerta &&
  prev.titulo === next.titulo &&
  arraysIguais(prev.inconsistencias, next.inconsistencias)
);
